import { useField, useFormikContext } from 'formik';
import { type FC, type FocusEvent } from 'react';

import { DateTimeField } from '../../InputFields';

import type { InputProps } from '@/types/formTypes';

interface FormikDateTimeFieldProps {
  name: string;
  label: string;
  disabled?: boolean | string;
  inputProps?: InputProps;
}

const today = new Date().toISOString().split('T')[0];

export const FormikDateTimeField: FC<FormikDateTimeFieldProps> = ({
  name,
  label,
  disabled = false,
  inputProps = { ...(today && { min: today }) },
}) => {
  const [field, meta, helpers] = useField(name);
  const { values } = useFormikContext<Record<string, unknown>>();
  const isDisabled = typeof disabled === 'string' ? !values[disabled] : disabled;

  const handleBlur = (event: FocusEvent<HTMLInputElement>): void => {
    if (event.target.name === name || event.target.id === name) {
      helpers.setTouched(true);
    }
  };

  return (
    <DateTimeField
      id={field.name}
      name={field.name}
      value={field.value as string}
      onChange={field.onChange}
      onBlur={handleBlur}
      label={label}
      disabled={isDisabled}
      {...(meta.touched && { helperText: meta.error })}
      inputProps={inputProps}
    />
  );
};
